const snapshotFileIDs = Symbol("snapshotFileIDs");

function validKey(value) {
    return typeof value === "string" && value.length > 0 && value.trim() === value &&
        !/[.#$\[\]/\u0000-\u001f\u007f]/.test(value) &&
        !["__proto__", "constructor", "prototype"].includes(value);
}

function legacyIDs(item) {
    const ids = item?.LegacySignatoryIDs;
    if (ids == null) return [];
    if (typeof ids !== "object" || Array.isArray(ids) ||
        Object.entries(ids).some(([key, value]) => !validKey(key) || value !== true)) {
        throw new Error("Invalid signatory legacy identities");
    }
    return Object.keys(ids).sort();
}

export async function resolveSignatoryLocation(db, signatoriesPath, id) {
    if (!/^Matrices\/(MilitarySignatoryMatrix|SignatoryMatrix)\/Signatories$/.test(signatoriesPath) || !validKey(id)) {
        throw new Error("Invalid signatory location");
    }
    const location = `${signatoriesPath}/${id}`;
    const direct = await db.once(location);
    if (direct != null) {
        if (direct.ID !== id || (direct.AccountID != null && !validKey(direct.AccountID))) throw new Error("Conflicting signatory identity");
        return location;
    }
    const matrixPath = signatoriesPath.slice(0, -"/Signatories".length);
    const uid = await db.once(`${matrixPath}/SignatoryAliases/${id}`);
    if (!validKey(uid) || uid === id) throw new Error("Signatory not found");
    const target = await db.once(`${signatoriesPath}/${uid}`);
    if (target?.ID !== uid || target?.AccountID !== uid || !legacyIDs(target).includes(id)) {
        throw new Error("Conflicting signatory alias");
    }
    return `${signatoriesPath}/${uid}`;
}

export function approvedSignatoryItem(item, revision) {
    if (!item) return item;
    const candidates = [item.ID, ...legacyIDs(item)].filter((id, index, ids) => ids.indexOf(id) === index);
    const matches = candidates.filter(id => Object.hasOwn(revision?.Signatories || {}, id));
    if (matches.length === 0) return null;
    if (matches.length !== 1) throw new Error("Ambiguous approved signatory identity");
    const historicalID = matches[0];
    const snapshot = revision.Signatories[historicalID];
    if (snapshot?.ID !== historicalID || snapshot?.AccountID !== item.AccountID) {
        throw new Error("Conflicting approved signatory identity");
    }
    return {
        ...snapshot,
        ID: item.ID,
        AccountID: item.AccountID,
        [snapshotFileIDs]: [historicalID, snapshot.OLD_SIG_ID],
    };
}

export function signatoryFileLocations(pageItem, filename) {
    if (typeof filename !== "string" || !filename || /[/\\\u0000-\u001f\u007f]/.test(filename) ||
        filename === "." || filename === "..") throw new Error("Invalid signatory filename");
    const identities = pageItem?.[snapshotFileIDs] || [pageItem?.ID, pageItem?.OLD_SIG_ID, ...legacyIDs(pageItem)];
    return [...new Set(identities.filter(validKey))].map(id => `people/${id}/${filename}`);
}

export async function findSignatoryFile(db, pageItem, filename) {
    console.log(signatoryFileLocations(pageItem, filename))
    for (const location of signatoryFileLocations(pageItem, filename)) {
        try {
            console.log(`Checking location: ${location}`);
            const url = await db.download(location);
            if (url) return url;
        } catch (error) {
            // if (error?.code !== "storage/object-not-found") throw error;
        }
    }
    return null;
}
